import { useCallback } from 'react'
import { useTapelineStore } from '@editorStores'
import { useHotkeys_ShortAndLongPress } from 'src/hooks/useHotkeysShiftX'
import { longPressTapelineMode, nextTapelineMode } from './utils'

/**
 * Short press cycles draw-only and show-only. Long press clears both modes, or shows tapelines
 * when both are off.
 */
const useTapelineModeHotkey = (): void => {
  const cycleTapelineMode = useCallback(() => {
    const { isActive, isVisible, isDrawing } = useTapelineStore.getState()
    const next = nextTapelineMode({ isActive, isVisible })
    useTapelineStore.setState({
      isActive: next.isActive,
      isVisible: next.isVisible,
      isDrawing: next.isActive ? isDrawing : false,
    })
  }, [])

  const longPressTapeline = useCallback(() => {
    const { isActive, isVisible } = useTapelineStore.getState()
    const next = longPressTapelineMode({ isActive, isVisible })
    useTapelineStore.setState({
      isActive: next.isActive,
      isVisible: next.isVisible,
      isDrawing: false,
    })
  }, [])

  useHotkeys_ShortAndLongPress(['m'], cycleTapelineMode, longPressTapeline, {}, [
    cycleTapelineMode,
    longPressTapeline,
  ])
}

export default useTapelineModeHotkey
